// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2HpP_","name":"Header_name__Ve1JT","birthday":"Header_birthday__2mhrv","skeleton":"Header_skeleton__DwMzo"};